module.exports = __webpack_public_path__ + "user_add_1.63cf03c6311aa121c5c22ec67f0d9f4c.svg";